import { Grid } from "@mui/material";

const InfoFieldsContainer = (props) => {
	return (
		<Grid container wrap="nowrap" direction="column">
			{props.children}
		</Grid>
	)
}

export default InfoFieldsContainer;